import { useState } from "react";
import { faqs } from "@/mocks/colors";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-background-100/70 border-t border-background-200 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-10">
        <div>
          <p className="flex items-center gap-3 text-accent-700 text-xs tracking-display uppercase">
            <span className="font-number text-lg">05</span>
            <span className="inline-block w-8 h-px bg-accent-500" />
            常见问题
          </p>
          <h2 className="mt-4 font-serif text-foreground-950 text-2xl md:text-[32px] font-semibold leading-snug">
            关于黑色系色号与使用
          </h2>
          <p className="mt-4 text-[15px] leading-7 text-foreground-600">
            从色号体系到印刷偏色，把图鉴使用中最常遇到的问题集中解答。没找到答案，可在页脚通过邮件与我们交流。
          </p>
          <a
            href="#contact"
            className="mt-6 inline-flex items-center gap-2 text-accent-700 font-medium text-sm hover:text-accent-800"
          >
            联系图鉴编辑部
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className={`rounded-lg border bg-background-50 overflow-hidden transition-colors ${
                  open ? "border-accent-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={open}
                >
                  <span className="flex items-start gap-3">
                    <span className={`font-number text-lg mt-0.5 ${open ? "text-accent-600" : "text-foreground-400"}`}>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="text-foreground-950 font-medium text-[15px] leading-6">{f.q}</h3>
                  </span>
                  <span
                    className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full border transition-colors ${
                      open ? "bg-accent-500 text-background-50 border-accent-500 rotate-45" : "border-background-300 text-foreground-600"
                    }`}
                  >
                    <i className="ri-add-line text-lg" />
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-[54px]">
                    <p className="text-[14px] leading-7 text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}